<template>
	<ValidationObserver
		tag="form"
		v-slot="{ handleSubmit }"
		@submit.prevent
	>
		<section class="form-col mb-6">
			<ValidationProvider tag="fieldset" rules="required" v-slot="{ errors }">
				<legend class="form-legend font-size-h3 bb-1 pb-1 mb-5">{{ $content.gift_delivery_method }}:</legend>
				<div class="flex flex-wrap pl-6 pr-6">
					<div class="radio-card b-shadow">
						<label class="radioControl">
							<input type="radio" name="giftDeliveryMethod" value="printCoupon" v-model="giftDeliveryMethod">
							<span class="radio"></span>
							{{ $content.printCoupon }}
						</label>
					</div>
					<div class="radio-card b-shadow">
						<label class="radioControl">
							<input type="radio" name="giftDeliveryMethod" value="sendEmail" v-model="giftDeliveryMethod">
							<span class="radio"></span>
							{{ $content.sendCoupon }}
						</label>
					</div>
				</div>
				<div class="pl-6 pr-6">
					<p class="form-error pl-1 pr-1">{{ errors[0] }}</p>
				</div>
			</ValidationProvider>
		</section>

		<section class="form-col mb-6">
			<h3 class="form-legend font-size-h3 bb-1 pb-1 mb-5">{{ $content.gift_for }}:</h3>
			<div class="pl-6 pr-6">
				<div class="form-row">
					<div class="form-field form-required mb-4">
						<label for="giftRecipientName" class="label">{{ $content.name }}:</label>
						<ValidationProvider
							mode="lazy"
							rules="required"
							v-slot="{ errors }">
							<input
								id="giftRecipientName"
								name="recipientName"
								class="form-control"
								type="text"
								v-model="giftRecipientName"
							/>
							<p class="form-error">{{ errors[0] }}</p>
						</ValidationProvider>
					</div>
				</div>

				<transition name="fade" mode="out-in">
					<template v-if="giftDeliveryMethod === 'sendEmail'">
						<div class="form-row">
							<div class="form-field form-required mb-4">
								<label for="giftRecipientEmail" class="label">{{ $content.emailAddress }}:</label>
								<p class="c-gray font-size-sm">({{ $content.emailMsg }})</p>
								<ValidationProvider
									mode="lazy"
									rules="required_if:giftDeliveryMethod,sendEmail|required"
									v-slot="{ errors }">
									<input
										id="giftRecipientEmail"
										name="recipientEmail"
										class="form-control"
										type="email"
										v-model="giftRecipientEmail"
									/>
									<p class="form-error">{{ errors[0] }}</p>
								</ValidationProvider>
							</div>
							<div class="form-field form-required mb-4">
								<label for="giftRecipientMsg" class="label">{{ $content.dedication }}:</label>
								<p class="c-gray font-size-sm">({{ $content.dedicationMsg }})</p>
								<ValidationProvider
									mode="lazy"
									rules="required_if:giftDeliveryMethod,sendEmail|required"
									v-slot="{ errors }">
                    <textarea
											id="giftRecipientMsg"
											name="recipientMsg"
											class="form-control"
											maxlength="500"
											v-model="giftRecipientMsg"></textarea>
									<p class="form-error">{{ errors[0] }}</p>
								</ValidationProvider>
							</div>
						</div>
					</template>
				</transition>

				<div class="flex flex-justify-center mt-6">
					<button @click="handleSubmit(onSubmit)" type="submit" class="btn btn-primary btn-max">{{ $content.next }}
					</button>
				</div>

			</div>
		</section>
	</ValidationObserver>
</template>

<script>
	import { ValidationProvider, ValidationObserver } from 'vee-validate';
	import { mapGetters } from 'vuex';

	export default {
		name: 'GiftDelivery',
		components: {
			ValidationProvider,
			ValidationObserver
		},
		computed: {
			giftDeliveryMethod: {
				get () {
					return this.$store.state.giftData.deliveryMethod
				},
				set (value) {
					this.$store.commit('setGiftDeliveryMethod', {giftDeliveryMethod: value })
				}
			},
			giftRecipientName: {
				get () {
					return this.$store.state.giftData.name
				},
				set (value) {
					this.$store.commit('setGiftRecipientName', {giftRecipientName: value })
				}
			},
			giftRecipientEmail: {
				get () {
					return this.$store.state.giftData.email
				},
				set (value) {
					this.$store.commit('setGiftRecipientEmail', {giftRecipientEmail: value })
				}
			},
			giftRecipientMsg: {
				get () {
					return this.$store.state.giftData.message
				},
				set (value) {
					this.$store.commit('setGiftRecipientMsg', {giftRecipientMsg: value })
				}
			},
			...mapGetters({
				giftData: 'GET_GIFT_DATA',
			})
		},
		methods: {
			onSubmit() {
				this.$store.commit('saveUserInSession');
				this.$store.commit('saveGiftInSession');
				this.nextStep();
			},
			nextStep() {
				this.$store.commit('setActiveStep', { activeStep: 'SummaryStep' });
			}
		}
	}
</script>

<style scoped>

</style>
